// eslint-disable-next-line
import React, { useEffect, useState, useCallback, useRef } from "react";
import debounce from "lodash.debounce";
import CreatableSelect from "react-select/creatable";
import { v4 as uuidv4 } from "uuid";
import ReactPlayer from "react-player";
import {
  getAvailableAssetsByUser,
  getClassProfileById,
  storeClassProfile,
  updateClassProfile,
} from "../../services/profile-class.service";
/* Components */
import Button from "../button/button";
import { useMutation } from "react-query";
import { useMixPanel } from "../../hooks/useMixPanel";
import { useTranslation } from "react-i18next";
import useGlobalStore from "../../store/useGlobalStore";
import { FormProvider, useForm, Controller } from "react-hook-form";
import TextInput2 from "../form-elements/TexInput2/TextInput2";
import { MIX_PANEL_EVENTS, PERU_SPANISH } from "../../utils/constans";
import AsyncSelect from "react-select/async";
// import Idea from "../../assets/icons/idea2.svg";
import {
  createGradeLevelSingle,
  getAllGradeLevelsByUser,
} from "../../services/grade-levels.service";
import { getAllAcademicPeriod } from "../../services/academic-period.service";
import {
  createSubjectAreaSingle,
  getAllSubjectAreasByAreas,
  // getAllSubjectAreasByInstitution,
  getAllSubjectAreasByPrograms,
  getAllSubjectAreasByUser,
} from "../../services/subject-area.service";
import { getInstitutionsByName } from "../../services/institution";
import SelectInput from "../form-elements/SelectInput/SelectInput";
import { useLocation, useNavigate } from "react-router-dom";
import useSnackbarStore from "../../store/snackbarStore";
import useSessionStore from "../../store/useSessionStore";
import Modal3 from "../modal3/modal3";
import DaySelector from "../form-elements/daySelector/daySelector";
import { getAllAreas } from "../../services/area.service";
import PDFFile from "../..//assets/icons/pdf_icon.svg";
import FileUploaderCourseProfile from "../FileUploaderCourseProfile/FileUploaderCourseProfile";
import { getDbaByGrade } from "../../services/dba.service";
// import { fetchChatGPT } from "../../services/chat.service";
import { deleteAssetByClassProfile } from "../../services/asset.service";
import classNames from "classnames";
import {
  getCompetences,
  getSubjectAndGradesCompetences,
} from "../../services/competences.service";
import useCompetenciesStore from "../competencies/hooks/useCompetenciesStore";
import useInstitutionLang from "../../hooks/useInstitutionLang";
import SkillSelector from "../form-elements/performanceSelector/pSelector";

const SelectStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: "rgb(182 182 182 / 0.25)",
    borderColor: "transparent",
    borderRadius: "4px",
    caretColor: "white",
    "&:hover": { borderColor: "transparent" }, // Borde en hover
  }),
  input: (provided) => ({
    ...provided,
    color: "#F7F5F2",
    fontWeight: "bold", // Establece el color del texto del input a blanco
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? "#F2F2F2" : "#FEFEFE",
    color: "black",
    cursor: "pointer",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#FEFEFE", // Color del indicador
    "&:hover": {
      color: "#3FB2E3", // Color del indicador en hover
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#fefefe", // Establece el color del texto de la opción seleccionada a blanco
    fontWeight: "bold",
  }),
  clearIndicator: (styles) => ({
    ...styles,
    color: "black", // Aquí puedes poner el color que desees
    ":hover": {
      color: "black", // Color cuando se pasa el ratón por encima (hover)
    },
  }),
};

const FormCourseProfile = ({ selectedRow, reloadList = null }) => {
  const [selectedDaysData] = useState([]);
  const { sendEvent } = useMixPanel();
  const { t, i18n } = useTranslation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedResources, setSelectedResources] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [showDbaModal, setShowDbaModal] = useState(false);
  const [showDbaList, setShowDbaList] = useState(false);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [showVideotModal, setShowVideotModal] = useState(false);
  const [
    showConfirmationAssetDeleteModal,
    setShowConfirmationAssetDeleteModal,
  ] = useState(false);
  const [areaKnowledge, setAreaKnowledge] = useState([]);
  const [standard, setStandard] = useState([]);
  const [performance, setPerformance] = useState([]);
  const [selectedDbaList, setSelectedDbaList] = useState([]);
  const [dba, setDba] = useState([]);
  const [editMode, setEditMode] = useState(null);
  const [editedDescription, setEditedDescription] = useState("");
  const [competenceData, setCompetenceData] = useState({});

  const { gptLoading } = useGlobalStore();

  const methods = useForm({
    mode: "onChange",
  });
  const {
    handleSubmit,
    setValue,
    getValues,
    watch,
    reset,
    formState: { errors },
  } = methods;
  const [gradeLevelOptions, setGradeLevelOptions] = useState([]);
  const [subjectAreaOptions, setSubjectAreaOptions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [availableAssets, setAvailableAssets] = useState([]);
  const [gradeLevels, setGradeLevels] = useState([]);
  const [subjectAreas, setSubjectAreas] = useState([]);
  const [academicPeriods, setAcademicPeriods] = useState([]);
  const [areas, setAreas] = useState([]);
  const [showAreas, setShowAreas] = useState(false);
  const [showCreateSubjectAreaButton, setShowreateSubjectAreaButton] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [filesToDelete] = useState([]);
  const [isCesa, setIsCesa] = useState(false);
  const [errorCalendar, setErrorCalendar] = useState(false);
  const [selectedAssetId, setSelectedAssetId] = useState(false);
  const location = useLocation();
  const userString = localStorage.getItem("user");
  const userObject = userString ? JSON.parse(userString) : "";
  const editParamId = new URLSearchParams(location.search).get("edit");
  const queryParams = new URLSearchParams(location.search);
  const level = queryParams.get("level");
  const { show } = useSnackbarStore();
  const { user } = useSessionStore();
  const [isNewSubjectModalOpen, setIsNewSubjectModalOpen] = useState(false);
  const [competenciesError] = useState(false);
  const [isNewGradeLevelModalOpen, setIsNewGradeLevelModalOpen] =
    useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [, setDebouncedSearchTerm] = useState("");
  // const temporalLoadingRef = useRef(false);
  const assetId = useRef(false);
  const selectedInstitution = watch("institution");
  const selectedArea = watch("area");
  const selectedProgram = watch("program");
  const selectedGradeLevel = watch("gradeLevels");
  const selecteddKnowledgeArea = watch("areaKnowledge");
  const selecteddStandard = watch("standard");
  const selectedPerformance = watch("performance");
  const gradeWatch = watch("gradeLevels");
  const subjectWatch = watch("subjectAreas");
  const cesaReferences = ["Pregrado", "Posgrado"];
  const competencesStore = useCompetenciesStore();
  const userLang = useInstitutionLang();
  const displayExtraFields = useCallback(
    () => userLang === PERU_SPANISH,
    [userLang]
  );
  const navigate = useNavigate();
  console.log('selectedProgram ', selectedProgram);
  useEffect(() => {
    if (isCesa && selected && areas.length) {
      const currentArea = areas.find((e) => {
        const find = selected?.subjectAreas?.find(
          (sa) => sa?.area?.id === e.id
        );
        return !!find;
      });
      if (currentArea) {
        setValue("area", {
          value: currentArea.id,
          label: currentArea.description,
        });
        const subjecAreasMapper = selected?.subjectAreas?.map((e) => ({
          label: e.name,
          value: e.id,
        }));
        setValue("subjectAreas", subjecAreasMapper);
      }
    }

    if (isCesa && selected && !areas.length && subjectAreas.length) {
      const subjecAreasMapper = selected?.subjectAreas?.map((e) => ({
        label: e.name,
        value: e.id,
      }));
      setValue("subjectAreas", subjecAreasMapper);
    }
    // eslint-disable-next-line
  }, [selected, areas, isCesa, subjectAreas]);

  useEffect(() => {
    if (
      isCesa &&
      selectedGradeLevel &&
      selectedGradeLevel.label === "Pregrado" &&
      user
    ) {
      setShowAreas(true);
      setValue("subjectAreas", []);
      mutationGeAreas.mutate();
      mutationGetSubjectAreasByAreas.mutate(user.email);
      if (academicPeriods.length) {
        const filteredAcademiceriod = academicPeriods.map((e) => ({
          ...e,
          show: e.level === "Terciaria o superior",
        }));
        setAcademicPeriods(filteredAcademiceriod);
      }
    } else if (
      isCesa &&
      selectedGradeLevel &&
      selectedGradeLevel.label === "Posgrado" &&
      user
    ) {
      setShowAreas(false);
      setValue("subjectAreas", []);
      mutationGetSubjectAreasByPrograms.mutate(user.email);
    } else {
      if (user) {
        if (userLang !== PERU_SPANISH) {
          mutationGetSubjectAreas.mutate(user.email);
        }
        if (isCesa) mutationGetAcademicPeriods.mutate();
      }
    }
    const getShowCreatSubjectArea = getshowCreateSubjectAreaButton();
    setShowreateSubjectAreaButton(getShowCreatSubjectArea);
    // eslint-disable-next-line
  }, [selectedGradeLevel, user, isCesa, userLang]);

  useEffect(() => {
    if (isCesa && selectedArea) {
      // setValue("subjectAreas", "");
    }
  }, [selectedArea, isCesa]);

  // Actualiza debouncedSearchTerm después de que el usuario deja de escribir
  useEffect(() => {
    // Crea una función debounced que actualiza debouncedSearchTerm
    const debouncedUpdate = debounce((search) => {
      setDebouncedSearchTerm(search);
    }, 500); // 500 ms de espera

    if (searchTerm) {
      debouncedUpdate(searchTerm);
    }

    // Limpia el debounce si el componente se desmonta o el searchTerm cambia
    return () => debouncedUpdate.cancel();
    // eslint-disable-next-line
  }, [searchTerm]);

  useEffect(() => {
    if (user && user?.institutionalUser?.subscription?.institution) {
      getInstitutionsByName(
        user.institutionalUser.subscription.institution.name
      ).then((instRes) => {
        const findInstitution = instRes.find(
          (e) => e.name === user.institutionalUser.subscription.institution.name
        );
        if (findInstitution) {
          setValue("institution", {
            label: findInstitution.name,
            value: findInstitution.id,
            grade_level: findInstitution.grade_level,
          });
        }
      });
    } else {
      setValue("institution", "");
    }
    mutationGetAcademicPeriods.mutate();
    // eslint-disable-next-line
  }, [user]);

  useEffect(() => {
    sendEvent(MIX_PANEL_EVENTS.contextUseCaseView);
    // eslint-disable-next-line
  }, []);

  const toggleNewSubjectModal = (e) => {
    e.preventDefault();
    setIsNewSubjectModalOpen(!isNewSubjectModalOpen);
    if (!isNewSubjectModalOpen) {
      setValue("new_name_subject", "");
    }
  };

  useEffect(() => {
    if (selectedGradeLevel && !displayExtraFields()) {
      mutationGetDbaByGrade.mutate(selectedGradeLevel.value);
    }
    // eslint-disable-next-line
  }, [selectedGradeLevel]);

  const getshowCreateSubjectAreaButton = () => {
    if (isCesa) {
      return false;
    }
    return true;
  };

  const toggleNewGradeLevelModal = (e) => {
    e.preventDefault();
    setIsNewGradeLevelModalOpen(!isNewGradeLevelModalOpen);
    if (!isNewGradeLevelModalOpen) {
      setValue("new_name_grade", "");
    }
  };

  // Funciones para manejar la creación de una nueva materia o grado
  const handleNewRegister = (event, type, field) => {
    const newName = getValues(field);
    event.preventDefault();

    const payload = {
      name: newName,
      user_email: user?.email,
      lang: i18n.language,
    };

    if (type === "grade") {
      mutationCreateGradeLevel.mutate(payload);
    }
    if (type === "subject-area") {
      mutationCreateSubjectArea.mutate(payload);
    }
  };

  const deletePerformance = (currentCompecentes) => {
    competencesStore.removePerformance(
      currentCompecentes.performance,
      competenceData
    );
  };

  const renderCompetenceList = () => {
    return competencesStore.performances.map((e, i) => {
      const findCompetence = competenceData.find((cd) => cd.performance === e);
      return (
        <div
          key={i}
          className="flex-1 min-w-75 max-w-80 flex flex-col gap-2 items-start justify-center p-4 rounded-2 bg-LightBlue-500/10"
        >
          <label className="text-LightBlue-500 font-black text-2.5 leading-3 uppercase">
            Desempeño
          </label>
          <p className="text-Grey-500 text-base leading-4 mb-2">
            {e.length > 160 ? `${e.substring(0, 160)}...` : e}
          </p>
          <span className="text-Grey-500 text-sm leading-3.5">
            <strong className="text-LightBlue-500">Competencia:</strong>{" "}
            {findCompetence?.competence}
          </span>
          <div className="flex justify-center font-bold text-center w-full pt-3">
            <div className="button button-primary border rounded-lg">
              <button
                type="button"
                onClick={() => deletePerformance(findCompetence)}
              >
                Eliminar
              </button>
            </div>
          </div>
        </div>
      );
    });
  };

  const onSubmit = (formData) => {
    console.log("formData :>> ", formData);
    const formDataToSend = new FormData();

    if (
      !displayExtraFields() &&
      showCalendar() &&
      !formData?.calendario?.length
    ) {
      setErrorCalendar(true);
      return;
    }
    setErrorCalendar(false);
    formDataToSend.append("user_email", userObject?.email);

    if (formData?.class_name) {
      formDataToSend.append("class_name", formData.class_name);
    }

    if (formData?.existing_asset) {
      formDataToSend.append("existing_asset", formData.existing_asset);
    }

    if (formData?.number_students) {
      formDataToSend.append("number_students", formData.number_students);
    }

    if (formData?.student_ages) {
      formDataToSend.append("student_ages", formData.student_ages);
    }

    if (formData?.session_number) {
      formDataToSend.append("session_number", formData.session_number);
    }

    if (formData?.special_considerations) {
      formDataToSend.append(
        "special_considerations",
        formData.special_considerations
      );
    }

    if (formData?.gradeLevels) {
      formDataToSend.append(
        "grade_level_ids",
        JSON.stringify([formData.gradeLevels.value])
      );
    }

    if (formData?.subjectAreas) {
      formDataToSend.append(
        "subject_area_ids",
        JSON.stringify([formData.subjectAreas.value])
      );
    }

    if (formData?.academicPeriod?.value) {
      formDataToSend.append(
        "academic_period_id",
        Number(formData.academicPeriod.value) || null
      );
    }

    if (formData?.objectives) {
      formDataToSend.append(
        "objective_list",
        JSON.stringify(
          formData.objectives.map((e) => ({ label: e.label, value: e.value }))
        )
      );
    }

    if (formData?.considerations) {
      formDataToSend.append(
        "consideration_list",
        JSON.stringify(
          formData.considerations.map((e) => ({
            label: e.label,
            value: e.value,
          }))
        )
      );
    }

    if (formData?.resources) {
      formDataToSend.append(
        "resource_list",
        JSON.stringify(
          formData.resources.map((e) => ({
            label: e.label,
            value: e.value,
          }))
        )
      );
    }

    if (formData?.previousKnowledge) {
      formDataToSend.append(
        "previous_knowledge_list",
        JSON.stringify(
          formData.previousKnowledge.map((e) => ({
            label: e.label,
            value: e.value,
          }))
        )
      );
    }

    if (selectedDbaList.length) {
      formDataToSend.append(
        "dba_ids",
        JSON.stringify(selectedDbaList.map((e) => e.id))
      );
    }

    if (competencesStore.competenceRegisters.length) {
      formDataToSend.append(
        "competence_list",
        JSON.stringify(competencesStore.competenceRegisters.map((e) => e.id))
      );
    }

    if (selectedResources.length) {
      selectedResources.forEach((element, i) => {
        if (element.file instanceof File) {
          formDataToSend.append(`resources[${i}][file]`, element.file);
          formDataToSend.append(`resources[${i}][asset]`, element?.asset || "");
          formDataToSend.append(
            `resources[${i}][description]`,
            element.description
          );
        }
      });
    }

    if (formData?.institution && Object.values(formData?.institution)?.length) {
      formDataToSend.append(
        "institution_id",
        formData?.institution?.value || null
      );
    }

    if (formData?.calendario?.length) {
      formDataToSend.append("calendar", JSON.stringify(formData.calendario));
    }

    if (filesToDelete.length) {
      formDataToSend.append("assets_to_delete", JSON.stringify(filesToDelete));
    }

    setLoading(true);
    const body = formDataToSend;
    if (selected && editParamId) {
      mutationUpdateClassProfile.mutate({
        id: selected?.id,
        body,
      });
    } else {
      mutationStoreClassProfile.mutate(body);
    }
  };

  const filterGradeLevelOptions = (inputValue) => {
    return gradeLevelOptions.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  const filterSubjectAreaOptions = (inputValue) => {
    return subjectAreaOptions.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  const loadGradeLevelOptions = (inputValue, callback) => {
    setTimeout(() => {
      callback(filterGradeLevelOptions(inputValue));
    }, 0);
  };

  const loadSubjectAreaOptions = (inputValue, callback) => {
    setTimeout(() => {
      callback(filterSubjectAreaOptions(inputValue));
    }, 0);
  };

  const handleFiles = (files) => {
    setSelectedResources(files);
    const mapperAssets = files.map((e) => ({
      ...e,
      name: e.file.name,
      index_uri: e.file.name,
      description: e.description,
      local: true,
      id: uuidv4(),
    }));
    if (files.length && selected && selected.assets) {
      setSelected({
        ...selected,
        assets: [...selected?.assets, ...mapperAssets],
      });
    } else {
      setSelected({ assets: mapperAssets });
    }
  };

  const handleEdit = (asset) => {
    setEditMode(asset.id);
    setEditedDescription(asset.description);
  };

  const handleCancel = () => {
    setEditMode(null);
    setEditedDescription("");
  };

  const handleSave = (id) => {
    // Aquí debes implementar la lógica para guardar la descripción actualizada en tu backend
    const updatedAssets = selected.assets.map((asset) =>
      asset.id === id ? { ...asset, description: editedDescription } : asset
    );
    setSelected({ ...selected, assets: updatedAssets });
    setEditMode(null);
    setEditedDescription("");
  };

  // eslint-disable-next-line
  const debouncedLoadOptions = useCallback(
    debounce((inputValue, callback) => {
      if (!inputValue) {
        callback([]);
        return;
      }

      // useCallback para memorizar la función debounced
      getInstitutionsByName(inputValue).then((institutions) => {
        const options = institutions.map((institution) => ({
          label: institution.name,
          value: institution.id,
          grade_level: institution.grade_level,
        }));
        if (options.length === 0) {
          // Si no hay opciones, muestra el modal
          setValue("newInstitution", inputValue);
        } else {
          setValue("newInstitution", "");
          // Si hay opciones, asegúrate de que el modal no se muestre
        }
        callback(options);
      });
    }, 1000),
    []
  );

  const openDbaModal = () => {
    setShowDbaModal(true);
  };

  const handleDeleteDba = (id) => {
    const selectedDbaFiltered = selectedDbaList.filter((e) => e.id !== id);
    setSelectedDbaList(selectedDbaFiltered);
  };

  const onDescriptionSelected = (event) => {
    const description = event?.target?.value || "";

    if (assetId.current) {
      const currentSelectedResources = selectedResources.map((e) => ({
        ...e,
        description: assetId.current === e.id ? description : e.description,
      }));
      const updatedAssets = selected.assets.map((asset) =>
        asset.id === assetId.current ? { ...asset, description } : asset
      );
      setEditedDescription(description);
      setSelectedResources(currentSelectedResources);
      setSelected({ ...selected, assets: updatedAssets });
    }
  };

  const openConfirmationDeleteAssetModal = (assetId) => {
    setSelectedAssetId(assetId);
    setShowConfirmationAssetDeleteModal(true);
  };

  const renderDocuments = () => (
    <div className="flex flex-col gap-3">
      <div className="input-instruction">
        {t("perfil_de_curso_general_documentos_anexados")}
      </div>
      <div
        className={classNames("cards-group", {
          "overflow-scroll h-[25vh]": selected.assets.length > 6,
        })}
      >
        {selected.assets.map((e) => (
          <div className="flex flex-col bg-LightBlue-500 bg-opacity-10 gap-3 p-4 rounded-1">
            <div className="flex gap-3 bg-LightBlue-500 bg-opacity-20 rounded-1 py-2 px-2 flex-1">
              <div className="flex items-center">
                <img src={PDFFile} alt="Archivo" className="max-w-full" />
              </div>
              <div className="flex flex-col">
                <div className="text-shaiaBlue">{e.index_uri}</div>
                <div className="text-white text-sm">120KB</div>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="text-3 text-shaiaBlue font-bold">
                {String("Descripción").toUpperCase()}
              </div>
              {editMode === e.id ? (
                <div className="w-full relative">
                  <div className="w-full flex gap-4 mt-auto">
                    <textarea
                      value={e.description}
                      onChange={onDescriptionSelected}
                      className={classNames(
                        "w-full h-32 p-4 pr-16 bg-[#fefefe21] text-white rounded text-xs ",
                        {
                          "border-2 border-white":
                            editMode === e.id && !editedDescription,
                        }
                      )}
                      placeholder="Ej. Este documento contiene el plan de estudios detallado..."
                    ></textarea>
                    {editMode === e.id && !editedDescription && (
                      <p className=" text-Red-500 font-bold text-sm">
                        Campo obligatorio
                      </p>
                    )}
                  </div>
                  {/* <button
                    type="button"
                    disabled={temporalLoadingRef.current || false}
                    onClick={() => generateDocumentDescription(e)}
                    className="flex items-center justify-around gap-2 absolute right-2 bottom-3 bg-Yellow-500 text-DarkBlue-500 p-2 rounded-lg py-1"
                  >
                    {temporalLoadingRef.current ? (
                      <div className="flex gap-1">
                        <div>
                          {t("perfil_de_curso_general_documentos_generando")}
                        </div>
                        <div className="animate-pulse flex space-x-2">
                          <span className="h-1 w-1 rounded-full bg-gray-400">
                            .
                          </span>
                          <span className="h-1 w-1 rounded-full bg-gray-400">
                            .
                          </span>
                          <span className="h-1 w-1 rounded-full bg-gray-400">
                            .
                          </span>
                        </div>
                      </div>
                    ) : (
                      "Generar descripción"
                    )}
                    <img src={Idea} alt="PDF Icon" className="w-5 h-5" />
                  </button> */}
                </div>
              ) : (
                <div className="text-white text-sm">{e.description}</div>
              )}
            </div>
            <div className="flex gap-3 justify-center">
              {editMode === e.id ? (
                <>
                  <button
                    type="button"
                    disabled={editMode === e.id && !editedDescription}
                    onClick={() => handleSave(e.id)}
                    className="button button-primary-outline"
                  >
                    {t("perfil_de_curso_general_documentos_guardar")}
                  </button>
                  <button
                    type="button"
                    onClick={handleCancel}
                    className="button red-button"
                  >
                    {t("perfil_de_curso_general_documentos_cancelar")}
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    onClick={() =>
                      openConfirmationDeleteAssetModal(e.asset || e.id)
                    }
                    className="button red-button"
                  >
                    {t("perfil_de_curso_general_documentos_eliminar")}
                  </button>
                  <button
                    type="button"
                    onClick={() => handleEdit(e)}
                    className="button button-primary-outline"
                  >
                    {t("perfil_de_curso_general_documentos_editar_descripcion")}
                  </button>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderDBA = (dbaItem, i) => {
    return (
      <div
        key={i}
        className=" bg-LightBlue-500 bg-opacity-10 p-4 w-80 h-auto rounded-2 gap-4 flex flex-col justify-between "
      >
        <div>
          <div className="text-shaiaBlue text-sm font-bold">
            {t("perfil_de_curso_general_estandar_dba")}
          </div>
          <div className="text-white ">
            {dbaItem.standard.length > 100
              ? `${dbaItem.standard.substring(0, 100)}...`
              : dbaItem.standard}
          </div>
        </div>
        <div>
          <div className="text-shaiaBlue text-sm font-bold">
            {t("perfil_de_curso_general_desempeno1")}
          </div>
          <div className="text-white">
            {dbaItem.performance.length > 100
              ? `${dbaItem.performance.substring(0, 100)}...`
              : dbaItem.performance}
          </div>
        </div>
        <div className="w-full flex justify-center">
          <button
            type="button"
            className="bg-DarkBlue-500 text-shaiaBlue border-shaiaBlue border-2 font-bold py-2 px-4 rounded-2"
            onClick={() => handleDeleteDba(dbaItem.id)}
          >
            {t("perfil_de_curso_general_dba_eliminar")}
          </button>
        </div>
      </div>
    );
  };

  const handleSelectDba = () => {
    const findDba = dba.find(
      (e) =>
        e.knowledge_area === selecteddKnowledgeArea.value &&
        e.standard === selecteddStandard.value &&
        e.performance === selectedPerformance.value
    );
    const currentSelectedDba = selectedDbaList.find(
      (e) =>
        e.knowledge_area === findDba.knowledge_area &&
        e.standard === findDba.standard &&
        e.performance === findDba.performance
    );
    if (findDba && !currentSelectedDba) {
      setSelectedDbaList([...selectedDbaList, { ...findDba }]);
    }
    setShowDbaModal(false);
    resetModal();
  };

  const setCurrenCourseProfile = (item) => {
    Object.keys(item).forEach((key) => {
      if (key === "subjectAreas" && Array.isArray(item[key])) {
        // Transforma y establece subjectAreas para AsyncSelect en formato { label, value }
        const currentSubjectArea = item[key].length
          ? {
              label: item[key][0].name,
              value: item[key][0].id,
            }
          : null;
        setValue("subjectAreas", currentSubjectArea);
      } else if (key === "gradeLevels" && Array.isArray(item[key])) {
        // Transforma y establece gradeLevels para AsyncSelect en formato { label, value }
        const currentGradeLevel = item[key].length
          ? {
              label:
                item[key][0].name.charAt(0).toUpperCase() +
                item[key][0].name.slice(1),
              value: item[key][0].id,
            }
          : null;
        setValue("gradeLevels", currentGradeLevel);
      } else if (key === "objectives" && Array.isArray(item[key])) {
        setValue(
          "objectives",
          item[key].map((o) => ({ label: o.description, value: o.id }))
        );
      } else if (key === "considerations" && Array.isArray(item[key])) {
        setValue(
          "considerations",
          item[key].map((o) => ({ label: o.description, value: o.id }))
        );
      } else if (key === "resources" && Array.isArray(item[key])) {
        setValue(
          "resources",
          item[key].map((o) => ({ label: o.description, value: o.id }))
        );
      } else if (key === "previousKnowledge" && Array.isArray(item[key])) {
        setValue(
          "previousKnowledge",
          item[key].map((o) => ({ label: o.description, value: o.id }))
        );
      } else if (key === "dbas" && Array.isArray(item[key])) {
        setSelectedDbaList(item[key]?.length ? item[key] : []);
        setShowDbaList(true);
      } else if (key === "competences" && Array.isArray(item[key])) {
        item[key].forEach((competenceElement) => {
          competencesStore.addCompetenceRegister(competenceElement);
        });
      } else if (key === "academicPeriod" && item[key]) {
        setValue("academicPeriod", {
          label: item[key].name,
          value: item[key].id,
        });
      } else if (
        key === "institution" &&
        item[key] &&
        user?.institutionalUser
      ) {
        setValue("institution", {
          label: item[key].name,
          value: item[key].id,
          grade_level: item[key].grade_level,
        });
      } else {
        // Para todos los demás valores del formulario
        setValue(key, item[key]);
      }
      if (!user?.institutionalUser) {
        setValue("institution", "");
      }
    });
  };

  const getCompetencesMutation = useMutation(getCompetences, {
    onSuccess: (data) => {
      setCompetenceData(data);
    },
    onError: () => {},
  });

  const mutationGetDbaByGrade = useMutation(getDbaByGrade, {
    onSuccess: (res) => {
      if (res?.length) {
        setDba(res);
        const uniqueAreas = new Set(res.map((e) => e.knowledge_area));
        const transformed = Array.from(uniqueAreas).map((e) => ({
          value: e,
          label: e,
        }));
        if (
          selected &&
          selected.gradeLevels.length &&
          selected.gradeLevels[0].name !== selectedGradeLevel.label
        ) {
          setSelectedDbaList([]);
        }
        setAreaKnowledge(transformed);
        setShowDbaList(true);
      } else {
        setSelectedDbaList([]);
        setShowDbaList(false);
      }
    },
    onError: (error) => {},
  });

  const mutationGetAvailableAssets = useMutation(getAvailableAssetsByUser, {
    onSuccess: (res) => {
      const parsedAssets = res.reduce((acc, assetItem) => {
        if (selected?.assets?.length) {
          const currentClassProfileAssets = selected?.assets.some(
            (e) => e.id === assetItem.id
          );
          if (!currentClassProfileAssets) {
            return [...acc, { ...assetItem }];
          }
          return acc;
        }
        return [...acc, { ...assetItem }];
      }, []);
      setAvailableAssets(parsedAssets);
    },
    onError: () => {},
  });

  const mutationGetAcademicPeriods = useMutation(getAllAcademicPeriod, {
    onSuccess: (res) => {
      setAcademicPeriods(res.map((e) => ({ ...e, show: true })));
    },
    onError: () => {},
  });

  const mutationStoreClassProfile = useMutation(storeClassProfile, {
    onSuccess: (data) => {
      setCurrenCourseProfile(data);
      show("Perfil Creado");
      setSelected(data);

      setLoading(false);
      reloadList && reloadList();
      navigate("/course-profile");
    },
    onError: () => {
      setLoading(false);
    },
  });

  const mutationUpdateClassProfile = useMutation(updateClassProfile, {
    onSuccess: (data) => {
      setCurrenCourseProfile(data);
      show("Perfil Actualizado");
      setSelected(data);
      setLoading(false);
      reloadList && reloadList();
    },
    onError: (error) => {
      setLoading(false);
    },
  });

  const mutationClassProfileById = useMutation(getClassProfileById, {
    onSuccess: (data) => {
      setCurrenCourseProfile(data);
      setSelected(data);
      setLoading(false);
    },
    onError: (error) => {},
  });

  const mutationRemoveAssetByClassProfile = useMutation(
    deleteAssetByClassProfile,
    {
      onSuccess: (data) => {
        setCurrenCourseProfile(data);
        setSelected(data);
        setLoading(false);
        setShowConfirmationAssetDeleteModal(false);
      },
      onError: (error) => {
        setLoading(false);
      },
    }
  );

  const mutationCreateGradeLevel = useMutation(createGradeLevelSingle, {
    onSuccess: (newGradelevel) => {
      setValue("gradeLevels", {
        label: newGradelevel.name,
        value: newGradelevel.id,
      });
      mutationGetGrades.mutate(user.email);
      setIsNewGradeLevelModalOpen(false);
    },
    onError: (error) => {},
  });

  const mutationCreateSubjectArea = useMutation(createSubjectAreaSingle, {
    onSuccess: (newSubjectArea) => {
      setValue("subjectAreas", {
        label: newSubjectArea.name,
        value: newSubjectArea.id,
      });
      mutationGetSubjectAreas.mutate(user.email);
      setIsNewSubjectModalOpen(false);
    },
    onError: (error) => {},
  });

  const mutationGetGrades = useMutation(getAllGradeLevelsByUser, {
    onSuccess: (res) => {
      setGradeLevels(res);
    },
    onError: (error) => {},
  });

  const mutationGetSubjectAreas = useMutation(getAllSubjectAreasByUser, {
    onSuccess: (res) => {
      setSubjectAreas(res);
    },
    onError: (error) => {},
  });

  const mutationGetSubjectAreasByAreas = useMutation(
    getAllSubjectAreasByAreas,
    {
      onSuccess: (res) => {
        setSubjectAreas(res);
      },
      onError: (error) => {},
    }
  );

  // const mutationGetSubjectAreasByInstitution = useMutation(
  //   getAllSubjectAreasByInstitution,
  //   {
  //     onSuccess: (res) => {
  //       setSubjectAreas(res);
  //     },
  //     onError: (error) => {},
  //   }
  // );

  const mutationGetSubjectAreasByPrograms = useMutation(
    getAllSubjectAreasByPrograms,
    {
      onSuccess: (data) => {
        if(data?.subjectAreas?.length){
          setSubjectAreas(data.subjectAreas)
        }
        if(data?.programs?.length){
          setPrograms(data.programs)
          const currentSubjectArea = selected.subjectAreas.length ? selected.subjectAreas[0] : null
          if(selected && selected.gradeLevels.length && selected.gradeLevels[0].name === "Posgrado" && currentSubjectArea){
            setValue("program", {label: currentSubjectArea.program, value: currentSubjectArea.program})
          }
        }
        ;
      },
      onError: (error) => {},
    }
  );

  const mutationGeAreas = useMutation(getAllAreas, {
    onSuccess: (res) => {
      setAreas(res);
    },
    onError: (error) => {},
  });

  useEffect(() => {
    if (gradeLevels.length && selectedInstitution) {
      const transformed = gradeLevels
        .filter((gradeItem) => {
          if (isCesa) {
            return (
              gradeItem.is_default && cesaReferences.includes(gradeItem.name)
            );
          }
          return gradeItem.level === selectedInstitution.grade_level;
        })
        .map((level) => ({
          value: level.id,
          label: level.name,
        }));

      setGradeLevelOptions(transformed);
      if (level === "pregrado") {
        const findCurrentGrade = transformed.find(
          (e) => e.label === "Pregrado"
        );
        if (findCurrentGrade) {
          setValue("gradeLevels ", findCurrentGrade);
        }
      }
      if (level === "posgrado") {
        const findCurrentGrade = transformed.find(
          (e) => e.label === "Posgrado"
        );
        if (findCurrentGrade) {
          setValue("gradeLevels", findCurrentGrade);
        }
      }
    }
    // eslint-disable-next-line
  }, [gradeLevels, selectedInstitution, isCesa, level]);

  useEffect(() => {
    if (gradeLevels?.length && competenceData.length) {
      competencesStore.competenceRegisters.forEach((competenceElement) => {
        competencesStore.addCompetence(competenceElement.competence);
        competencesStore.addCapabilities(competenceElement.capability);
        competencesStore.addPerformance(competenceElement.performance);
      });
    }
    // eslint-disable-next-line
  }, [gradeLevels, competenceData]);

  useEffect(() => {
    if (gradeLevels.length && !user?.institutionalUser) {
      const transformed = gradeLevels.map((level) => ({
        value: level.id,
        label: level.name,
      }));
      setGradeLevelOptions(transformed);
    }
    // eslint-disable-next-line
  }, [gradeLevels, user]);

  useEffect(() => {
    if (userLang === PERU_SPANISH && user && displayExtraFields()) {
      mutationGetSubjectAndGradeCompetences.mutate(user.email);
    }
    // eslint-disable-next-line
  }, [userLang, user]);

  useEffect(() => {
    if (selectedRow) {
      Object.keys(selectedRow).forEach((key) => {
        if (key === "subjectAreas" && Array.isArray(selectedRow[key])) {
          const currentSubjectArea = selectedRow[key].length
            ? {
                label: selectedRow[key][0].name,
                value: selectedRow[key][0].id,
              }
            : null;
          setValue("subjectAreas", currentSubjectArea);
        } else if (key === "gradeLevels" && Array.isArray(selectedRow[key])) {
          // Transforma y establece gradeLevels para AsyncSelect en formato { label, value }
          const currentGradeLevel = selectedRow[key].length
            ? {
                label:
                  selectedRow[key][0].name.charAt(0).toUpperCase() +
                  selectedRow[key][0].name.slice(1),
                value: selectedRow[key][0].id,
              }
            : null;
          setValue("gradeLevels", currentGradeLevel);
        } else if (key === "academicPeriod" && selectedRow[key]?.id) {
          // Establece academicPeriod si existe en el formato correcto
          setValue("academicPeriod", {
            value: selectedRow[key].id,
            label: selectedRow[key].name,
          });
        } else {
          // Para todos los demás valores del formulario
          setValue(key, selectedRow[key]);
        }
      });
      setSelected({ ...selectedRow, id: selectedRow.classId });
    }
    // eslint-disable-next-line
  }, [selectedRow]);

  const showSubjectAreaDataByInsitution = (sa, isInstitution) => {
    if (isInstitution) {
      if (
        sa?.institution?.id === user.institutionalUser?.subscription?.institution?.id
      ) {
     
        return true;
      }
      if (selectedArea && sa?.area?.id === selectedArea.value) return true;
      if (selectedProgram && sa?.program === selectedProgram?.value) return true;
      if (sa.person?.email === user?.email) return true;
      return false;
    }
    return true;
  };
  console.log('subjectAreas ', subjectAreas);
  useEffect(() => {
    if (subjectAreas.length) {
      const isCesaInst =
        user?.institutionalUser?.subscription?.institution?.name ===
        "CESA - Colegio de Estudios Superiores de Administración";
      setIsCesa(isCesaInst);
      const transformed = subjectAreas.map((sa) => ({
        value: sa.id,
        label: sa.name,
        show: showSubjectAreaDataByInsitution(sa, isCesaInst),
      }));
      console.log('subjectAreas ', subjectAreas);
      setSubjectAreaOptions(transformed);
    }

    // eslint-disable-next-line
  }, [subjectAreas, user, selectedArea, selectedProgram]);

  useEffect(() => {
    if (editParamId) {
      mutationClassProfileById.mutate({ id: editParamId });
    } else {
      setSelectedResources([]);
      setSelected(null);
      reset();
    }
    // eslint-disable-next-line
  }, [editParamId]);

  useEffect(() => {
    if (!editParamId && academicPeriods && academicPeriods.length) {
      const findDefaultAcademicPeriod = academicPeriods.find(
        (_, index) => index === 0
      );
      let defaultAcademiPeriod = findDefaultAcademicPeriod.id;
      if (isCesa) {
        const findDefaultAcademicPeriodCESA = academicPeriods.find(
          (e) => e.name === "2024 Semestre 2"
        );
        if (findDefaultAcademicPeriodCESA)
          defaultAcademiPeriod = {
            value: findDefaultAcademicPeriodCESA.id,
            label: findDefaultAcademicPeriodCESA.name,
          };
      }
      setValue("academicPeriod", defaultAcademiPeriod);
    }
    // eslint-disable-next-line
  }, [editParamId, academicPeriods, isCesa]);

  useEffect(() => {
    if (user) {
      if (!availableAssets.length) {
        mutationGetAvailableAssets.mutate({ email: user.email });
      }
      mutationGetGrades.mutate(user.email);
      if (userLang !== PERU_SPANISH) {
        mutationGetSubjectAreas.mutate(user.email);
      }
    }
    // eslint-disable-next-line
  }, [user, userLang]);

  useEffect(() => {
    if (selecteddKnowledgeArea) {
      const filterStandard = dba.filter(
        (e) => e.knowledge_area === selecteddKnowledgeArea.value
      );
      const uniqueStandards = new Set(filterStandard.map((e) => e.standard));
      const transformed = Array.from(uniqueStandards).map((e) => ({
        value: e,
        label: e,
      }));
      setStandard(transformed);
      setPerformance([]);
      setValue("standard", null);
      setValue("performance", null);
    }
    // eslint-disable-next-line
  }, [selecteddKnowledgeArea]);

  useEffect(() => {
    if (selecteddKnowledgeArea && selecteddStandard) {
      const filterPerformance = dba.filter(
        (e) =>
          e.knowledge_area === selecteddKnowledgeArea.value &&
          e.standard === selecteddStandard.value
      );
      const uniquePerformance = new Set(
        filterPerformance.map((e) => e.performance)
      );
      const transformed = Array.from(uniquePerformance).map((e) => ({
        value: e,
        label: e,
      }));
      setPerformance(transformed);
      setValue("performance", null);
    }
    // eslint-disable-next-line
  }, [selecteddKnowledgeArea, selecteddStandard]);

  useEffect(() => {
    if (gradeWatch?.value && displayExtraFields()) {
      getCompetencesMutation.mutate({
        grade: gradeWatch.value,
        subject: 1,
      });
    }
    // eslint-disable-next-line
  }, [gradeWatch]);

  const mutationGetSubjectAndGradeCompetences = useMutation(
    getSubjectAndGradesCompetences,
    {
      onSuccess: (res) => {
        if (res.data) {
          setSubjectAreas(res.data.subjects);
        }
      },
      onError: (err) => {},
    }
  );

  const togglePopup = (e) => {
    e.preventDefault();
    setIsPopupOpen(!isPopupOpen);
  };

  // eslint-disable-next-line
  const loadInstitutionOptions = (inputValue, callback) => {
    debouncedLoadOptions(inputValue, callback);
  };

  const customSubmit = () => {
    handleSubmit(onSubmit)();
  };

  const closeDbaModal = () => {
    setShowDbaModal(false);
    resetModal();
  };

  const closeDocumentModal = () => {
    setShowDocumentModal(false);
    resetModal();
  };

  const closeVideoModal = () => {
    setShowVideotModal(false);
    resetModal();
  };

  const openDocumentModal = () => {
    setShowDocumentModal(true);
  };

  const handleCreateTag = (inputValue, field) => {
    const normalizedInput = inputValue.trim().toLowerCase();
    const isDuplicate =
      selected &&
      selected[field]?.some(
        (objective) =>
          objective.description.trim().toLowerCase() === normalizedInput
      );

    if (!isDuplicate) {
      // Aquí agregas la nueva etiqueta si no es duplicado
      const newOption = {
        id: inputValue, // Generar un ID falso; reemplazar con lógica adecuada
        description: inputValue,
      };

      // Actualizar tus estados o llamadas de API aquí
      if (selected && selected[field]) {
        setSelected((prevState) => ({
          ...prevState,
          [field]: [...prevState[field], newOption],
        }));
      } else {
        setSelected({ [field]: [newOption] });
      }

      const currentOptions = methods.getValues(field) || [];
      const updatedObjectives = [
        ...currentOptions,
        { label: newOption.description, value: newOption.id },
      ];

      methods.setValue(field, updatedObjectives, {
        shouldValidate: true,
      });
    } else {
      // Mostrar algún mensaje de error o manejar el error de duplicado
      alert("La etiqueta ya existe"); // Cambiar por una notificación más adecuada
    }
  };

  const resetModal = () => {
    setValue("areaKnowledge", null);
    setValue("standard", null);
    setValue("performance", null);
    setStandard([]);
    setPerformance([]);
    setShowDocumentModal(false);
  };

  const handleRemoveAsset = () => {
    setLoading(true);
    mutationRemoveAssetByClassProfile.mutate({
      classProfileId: selected?.id || null,
      assetId: selectedAssetId,
    });
  };
  const showCalendar = () => {
    if (displayExtraFields()) {
      return false;
    }
    if (isCesa) {
      if (selectedGradeLevel && selectedGradeLevel.label === "Pregrado") {
        return true;
      }
      return false;
    }
    if (user?.institutionalUser && !isCesa) return true;
    return false;
  };

  const showAcademicPeriod = () => {
    if (isCesa) {
      if (selectedGradeLevel && selectedGradeLevel.label === "Posgrado") {
        return false;
      }
      return true;
    }
    if (user?.institutionalUser && !isCesa) return true;
    return false;
  };

  const getStudentTranslation = () => {
    const translation = {
      name: t("perfil_de_curso_formulario_numero_sesiones"),
      instruction: t("perfil_de_curso_formulario_numero_sesiones_instruction"),
      placeholder: t("perfil_de_curso_formulario_numero_sesiones_placeholder"),
    };
    if (
      isCesa &&
      selectedGradeLevel &&
      selectedGradeLevel.label === "Pregrado"
    ) {
      translation.name = t(
        "perfil_de_curso_formulario_numero_sesiones_pregrado_cesa"
      );
      translation.instruction = t(
        "perfil_de_curso_formulario_numero_sesiones_instruction_pregrado_cesa"
      );
      translation.placeholder = t(
        "perfil_de_curso_formulario_numero_sesiones_placeholder_pregrado_cesa"
      );
    }
    if (
      isCesa &&
      selectedGradeLevel &&
      selectedGradeLevel.label === "Posgrado"
    ) {
      translation.name = t(
        "perfil_de_curso_formulario_numero_sesiones_posgrado_cesa"
      );
      translation.instruction = t(
        "perfil_de_curso_formulario_numero_sesiones_instruction_posgrado_cesa"
      );
      translation.placeholder = t(
        "perfil_de_curso_formulario_numero_sesiones_placeholder_posgrado_cesa"
      );
    }
    return translation;
  };

  const getCourseName = () => {
    const translation = {
      name: t("perfil_de_curso_formulario_nombre"),
      instruction: t("perfil_de_curso_formulario_nombre_instruccion"),
      placeholder: t("perfil_de_curso_formulario_placeholder_nombre"),
    };
    if (isCesa) {
      translation.name = t("perfil_de_curso_formulario_nombre_cesa");
    }
    if (
      isCesa &&
      selectedGradeLevel &&
      selectedGradeLevel.label === "Pregrado"
    ) {
      translation.name = t("perfil_de_curso_formulario_nombre_pregrado_cesa");
      translation.instruction = t(
        "perfil_de_curso_formulario_nombre_instruccion_pregrado_cesa"
      );
      translation.placeholder = t(
        "perfil_de_curso_formulario_placeholder_nombre_pregrado_cesa"
      );
    }
    if (
      isCesa &&
      selectedGradeLevel &&
      selectedGradeLevel.label === "Posgrado"
    ) {
      translation.name = t("perfil_de_curso_formulario_nombre_posgrado_cesa");
      translation.instruction = t(
        "perfil_de_curso_formulario_nombre_instruccion_posgrado_cesa"
      );
      translation.placeholder = t(
        "perfil_de_curso_formulario_placeholder_nombre_posgrado_cesa"
      );
    }
    return translation;
  };

  const toggleP = (e) => {
    if (e) e.preventDefault();
    setIsPopupOpen(!isPopupOpen);
  };

  const showSessionNumber = () => {
    if (displayExtraFields()) {
      return false;
    }
    if (isCesa) {
      if (selectedGradeLevel) {
        return true;
      }
      return false;
    }
    if (user?.institutionalUser && !isCesa) return true;
    return false;
  };

  const showCourseName = () => {
    if (isCesa) {
      if (selectedGradeLevel) {
        return true;
      }
      return false;
    }
    return true;
  };
  console.log('program list', programs);
  return (
    <>
      <FormProvider {...methods}>
        <div className="chat-content_title">
          <div className="welcome-text">
            <div className="flex flex-col gap-2">
              <div>
                <strong>{t("perfil_de_curso_general_titulo1")}</strong>
              </div>
              <div>
                {t("perfil_de_curso_general_titulo2_a")}{" "}
                <span>{t("perfil_de_curso_general_titulo2_b")}</span>
              </div>
              <div className="mt-2">
                <strong>{t("perfil_de_curso_general_titulo3")}</strong>
              </div>
            </div>
          </div>
          {/* <div
            className="text-shaiaBlue underline cursor-pointer"
            onClick={() => setShowVideotModal(true)}
          >
            {t("perfil_de_curso_general_video_url")}
          </div> */}
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="w-full h-full">
          <div className="input-row">
            {!isCesa && showCourseName() && (
              <div className="input-text">
                <TextInput2
                  label={getCourseName().name}
                  labelInstruction={getCourseName().instruction}
                  name="class_name"
                  placeHolder={getCourseName().placeholder}
                  maxLength={"60"}
                  customClassName={"mt-0"}
                  required
                />
              </div>
            )}
            <div className="input-text">
              <label className="input-label">
                {t(
                  isCesa
                    ? "perfil_de_curso_formulario_grado_cesa"
                    : "perfil_de_curso_formulario_grado"
                )}
              </label>
              <label className="input-instruction">
                {t(
                  isCesa
                    ? "perfil_de_curso_formulario_grado_instruccion_cesa"
                    : "perfil_de_curso_formulario_grado_instruccion"
                )}
              </label>
              <div className="flex justify-around gap-2">
                <div className="w-full">
                  <Controller
                    name="gradeLevels"
                    control={methods.control}
                    rules={{ required: t("campo_requerido") }}
                    render={({ field }) => (
                      <AsyncSelect
                        {...field}
                        cacheOptions
                        defaultOptions={gradeLevelOptions}
                        loadOptions={loadGradeLevelOptions}
                        styles={SelectStyles}
                        placeholder={t(
                          "perfil_de_curso_formulario_placeholder_grado"
                        )}
                      />
                    )}
                  />
                  {errors.gradeLevels && (
                    <span className="input-error">
                      {errors.gradeLevels.message}
                    </span>
                  )}
                </div>
                {!isCesa && false && (
                  <div>
                    <button
                      type="button"
                      onClick={toggleNewGradeLevelModal}
                      className="button-tertiary-rounded"
                    >
                      {t("perfil_de_curso_formulario_boton_crear_grado")}
                    </button>
                  </div>
                )}
              </div>
            </div>
            {isCesa && showCourseName() && (
              <div className="input-text">
                <TextInput2
                  label={getCourseName().name}
                  labelInstruction={getCourseName().instruction}
                  name="class_name"
                  placeHolder={getCourseName().placeholder}
                  maxLength={"60"}
                  customClassName={"mt-0"}
                  required
                />
              </div>
            )}
          </div>
          {user?.institutionalUser ? (
            <div className="input-row">
              <div className="input-text">
                <label className="input-label">{"Institución"}</label>
                <label className="input-instruction">
                  {t("perfil_de_curso_formulario_institucion_instruccion")}
                </label>
                <Controller
                  name="institution"
                  control={methods.control}
                  rules={{ required: t("campo_requerido") }}
                  render={({ field }) => (
                    <AsyncSelect
                      {...field}
                      cacheOptions
                      defaultOptions
                      loadOptions={loadInstitutionOptions} //eslint-disable-line
                      onInputChange={(value) => {
                        setSearchTerm(value); //eslint-disable-line
                      }}
                      onChange={(selectedOption) => {
                        field.onChange(
                          selectedOption ? selectedOption.value : null
                        );
                        setValue("institution", selectedOption, {
                          shouldValidate: true,
                        });
                      }}
                      value={field.value}
                      styles={SelectStyles}
                      placeholder={t("registro_campo_institution_placeholder")}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      disabled={!loading}
                    />
                  )}
                />
                {errors.institution && (
                  <span className="input-error">
                    {errors.institution.message}
                  </span>
                )}
              </div>
            </div>
          ) : null}

          <div className="input-row">
            {showAcademicPeriod() ? (
              <div className="input-text">
                <SelectInput
                  name="academicPeriod"
                  label={t("perfil_de_curso_formulario_periodo_academico")}
                  labelInstruction={t(
                    "perfil_de_curso_formulario_periodo_academico_instruccion"
                  )}
                  options={academicPeriods
                    ?.filter((e) => e.show)
                    ?.map((e) => ({
                      value: e.id,
                      label: e.name,
                    }))}
                  isDefaultValue={!selected ? true : false}
                  required
                  placeholder={t(
                    "perfil_de_curso_formulario_periodo_academico_placerholder"
                  )}
                />
                {errors.academicPeriod && (
                  <span className="input-error">
                    {errors.academicPeriod.message}
                  </span>
                )}
              </div>
            ) : null}
          </div>

          <div className="input-row">
            <Modal3
              isOpen={isNewSubjectModalOpen}
              onClose={toggleNewSubjectModal}
            >
              <div className="p-4 flex gap-2">
                <TextInput2
                  name="new_name_subject"
                  label={t(
                    isCesa
                      ? "perfil_de_curso_formulario_modal_materia_nombre_cesa"
                      : "perfil_de_curso_formulario_modal_materia_nombre"
                  )}
                  required={isNewSubjectModalOpen}
                  customClassName="mt-0"
                />
                <div className="flex justify-center items-end ">
                  <button
                    type="button"
                    onClick={(e) =>
                      handleNewRegister(e, "subject-area", "new_name_subject")
                    }
                    className="button-tertiary-rounded"
                  >
                    {t(
                      isCesa
                        ? "perfil_de_curso_formulario_materia_nuevo_guardar_cesa"
                        : "perfil_de_curso_formulario_materia_nuevo_guardar"
                    )}
                  </button>
                </div>
              </div>
            </Modal3>

            <Modal3
              isOpen={isNewGradeLevelModalOpen}
              onClose={toggleNewGradeLevelModal}
            >
              <div className="p-4 flex gap-2">
                <TextInput2
                  name="new_name_grade"
                  label={t(
                    isCesa
                      ? "perfil_de_curso_formulario_modal_grado_nombre_cesa"
                      : "perfil_de_curso_formulario_modal_grado_nombre"
                  )}
                  required={isNewGradeLevelModalOpen}
                  customClassName="mt-0"
                />
                <div className="flex justify-center items-end ">
                  <button
                    type="button"
                    onClick={(e) =>
                      handleNewRegister(e, "grade", "new_name_grade")
                    }
                    className="button-tertiary-rounded"
                  >
                    {t(
                      isCesa
                        ? "perfil_de_curso_formulario_grado_nuevo_guardar_cesa"
                        : "perfil_de_curso_formulario_grado_nuevo_guardar"
                    )}
                  </button>
                </div>
              </div>
            </Modal3>

            {isCesa && showAreas && (
              <div className="input-text">
                <SelectInput
                  name="area"
                  label={t("perfil_de_curso_formulario_area")}
                  labelInstruction={t(
                    "perfil_de_curso_formulario_area_instruccion"
                  )}
                  options={areas?.map((e) => ({
                    value: e.id,
                    label: e.description,
                  }))}
                  onChange={() => {
                    setValue("subjectAreas", "");
                  }}
                  required
                  placeholder={t(
                    "perfil_de_curso_formulario_area_placerholder"
                  )}
                />
                {errors.area && (
                  <span className="input-error">{errors.area.message}</span>
                )}
              </div>
            )}

            {isCesa && selectedGradeLevel?.label === "Posgrado" && (
              <div className="input-text">
                <SelectInput
                  name="program"
                  label={t("perfil_de_curso_formulario_programa_label")}
                  labelInstruction={t(
                    "perfil_de_curso_formulario_programa_instruction"
                  )}
                  options={programs?.map((e,i) => {
                    console.log('e ', e);
                    return {
                      value: e,
                      label: e,
                    }
                  })}
                  required
                  placeholder={t(
                    "perfil_de_curso_formulario_area_placerholder"
                  )}
                />
                {errors.program && (
                  <span className="input-error">{errors.program.message}</span>
                )}
              </div>
            )}

            <div className="input-text">
              <label className="input-label">
                {t(
                  isCesa
                    ? "perfil_de_curso_formulario_materia_cesa"
                    : "perfil_de_curso_formulario_materia"
                )}
              </label>
              <label className="input-instruction">
                {t(
                  isCesa
                    ? "perfil_de_curso_formulario_materia_instruccion_cesa"
                    : "perfil_de_curso_formulario_materia_instruccion"
                )}
              </label>
              <div className="flex justify-around gap-2">
                <div className="w-full">
                  <Controller
                    name="subjectAreas"
                    control={methods.control}
                    rules={{ required: t("campo_requerido") }}
                    render={({ field }) => (
                      <AsyncSelect
                        {...field}
                        cacheOptions
                        defaultOptions={subjectAreaOptions.filter(
                          (e) => e.show
                        )}
                        loadOptions={loadSubjectAreaOptions}
                        styles={SelectStyles}
                        placeholder={t(
                          isCesa
                            ? "perfil_de_curso_formulario_placeholder_materia_cesa"
                            : "perfil_de_curso_formulario_placeholder_materia"
                        )}
                      />
                    )}
                  />
                  {errors.subjectAreas && (
                    <span className="input-error">
                      {errors.subjectAreas.message}
                    </span>
                  )}
                </div>

                {showCreateSubjectAreaButton && (
                  <div>
                    <button
                      type="button"
                      onClick={toggleNewSubjectModal}
                      className="button-tertiary-rounded"
                    >
                      {t("perfil_de_curso_formulario_boton_crear_materia")}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="input-row">
            <div className="flex flex-col bg-LightBlue-500 bg-opacity-10 p-4 mt-8 gap-3 mb-5 w-full rounded-2">
              {!isCesa && !displayExtraFields() && showDbaList ? (
                <>
                  <div className="flex flex-col justify-start">
                    <div className="text-shaiaBlue font-bold">
                      {t("perfil_de_curso_general_derechos_aprendizaje")}
                    </div>
                    <div className="input-instruction !min-h-auto">
                      {t("perfil_de_curso_general_dba_pregunta_cursos")}
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-4">
                    {selectedDbaList.length
                      ? selectedDbaList.map((e, i) => renderDBA(e, i))
                      : null}
                    <div className="cursor-pointer bg-LightBlue-500 bg-opacity-10 border-dashed border border-LightBlue-400 border-opacity-50 p-4 w-80 gap-4 h-auto rounded-1 flex justify-center items-center">
                      <div
                        className="flex flex-col justify-center items-center gap-0"
                        onClick={() => openDbaModal()}
                      >
                        <span className="text-LightBlue-500 font-black text-12 leading-12">
                          +
                        </span>
                        <span className="text-shaiaBlue font-bold text-3">
                          {t("perfil_de_curso_general_dba_agregar")}
                        </span>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
              {displayExtraFields() &&
                subjectWatch?.value &&
                competenceData.length && (
                  <>
                    <div className="input-text">
                      <label className="input-label">{"Competencias"}</label>
                    </div>
                    {/* Aquí se renderizan los desempeños agregados */}
                    <div className="flex flex-wrap gap-4">
                      {competencesStore.competences.length &&
                      competencesStore.performances.length
                        ? renderCompetenceList()
                        : null}

                      {/* Botón para agregar desempeños */}
                      <button
                        onClick={(e) => toggleP(e)}
                        className="flex flex-col gap-4 items-center justify-center p-4 rounded-2 bg-LightBlue-500/10 hover:bg-LightBlue-500/20 transition-background cursor-pointer"
                      >
                        <span className="text-LightBlue-500 font-bold text-12 leading-3 uppercase my-4">
                          +
                        </span>
                        <span className="text-LightBlue-500 font-bold text-3 leading-3 uppercase">
                          Agregar otro desempeño
                        </span>
                      </button>
                    </div>
                    <SkillSelector
                      isOpen={isPopupOpen}
                      onClose={toggleP}
                      subjectAreas={subjectAreas?.value}
                      subjectWatch={subjectWatch?.value || null}
                      grade={gradeWatch?.value || ""}
                      SelectStyles={SelectStyles}
                      data={competenceData}
                      competencesStore={competencesStore}
                      showSubjectField={false}
                    />
                    {competenciesError && (
                      <p className="text-white pt-4 font-bold text-center">
                        Campo requerido: Seleccione minimo 1 Competencia
                      </p>
                    )}
                  </>
                )}

              {!isCesa && (
                <div className="input-instruction p-0 mt-4">
                  {t(
                    displayExtraFields()
                      ? "perfil_de_curso_general_objetivo_curricular_titulo_ensena_peru"
                      : "perfil_de_curso_general_objetivo_curricular_titulo"
                  )}
                </div>
              )}

              <div>
                <label className="input-label px-0 pt-0">
                  {t(
                    "perfil_de_curso_general_modal_dba_objetivo_curricular_label"
                  )}
                </label>
                <label className="input-instruction px-0">
                  {t(
                    "perfil_de_curso_general_modal_dba_objetivo_curricular_instruction"
                  )}
                </label>
                <div className="flex justify-around gap-2">
                  <div className="w-full">
                    <Controller
                      name="objectives"
                      control={methods.control}
                      rules={{ required: t("campo_requerido") }}
                      render={({ field }) => (
                        <CreatableSelect
                          {...field}
                          cacheOptions
                          options={selected?.objectives?.map((e) => ({
                            label: e.description,
                            value: e.id,
                          }))}
                          styles={SelectStyles}
                          isMulti
                          placeholder={t(
                            "perfil_de_curso_formulario_placeholder_grado"
                          )}
                          formatCreateLabel={(inputValue) =>
                            `Crear "${inputValue}"`
                          }
                          onCreateOption={(e) =>
                            handleCreateTag(e, "objectives")
                          }
                        />
                      )}
                    />
                    {errors.objectives && (
                      <span className="input-error">
                        {errors.objectives.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {false && (
            <div className="input-row flex-col">
              <div className="flex flex-col gap-3">
                <div className="input-label">
                  {t("perfil_de_curso_general_documentos_titulo1")}
                </div>
                <div className="input-instruction">
                  {t("perfil_de_curso_general_documentos_titulo2")}
                </div>
                <div className="input-instruction">
                  <strong>
                    {t("perfil_de_curso_general_documentos_formatos1")}
                  </strong>
                  {t("perfil_de_curso_general_documentos_formatos2")}
                  <br />
                  <br />
                  {t("perfil_de_curso_general_documentos_titulo3")}
                </div>
              </div>
              <div className="flex justify-center">
                <button
                  type="button"
                  className="bg-Yellow-500 text-black rounded p-2"
                  onClick={() => openDocumentModal()}
                >
                  {t("perfil_de_curso_general_documentos_cargar")}
                </button>
              </div>
              {selected && selected.assets && selected?.assets.length
                ? renderDocuments()
                : null}
            </div>
          )}
          <div className="input-row">
            <div name="input-text"></div>
          </div>
          <div className="input-row">
            {showSessionNumber() && (
              <TextInput2
                label={getStudentTranslation().name}
                labelInstruction={getStudentTranslation().instruction}
                name="session_number"
                placeHolder={getStudentTranslation().placeholder}
                maxLength={"20"}
                required
              />
            )}

            {user?.institutionalUser ? (
              <TextInput2
                label={t("perfil_de_curso_formulario_numero_estudiantes")}
                labelInstruction={t(
                  "perfil_de_curso_formulario_numero_estudiantes_instruction"
                )}
                name="number_students"
                placeHolder={t(
                  "perfil_de_curso_formulario_numero_estudiantes_placeholder"
                )}
                maxLength={"20"}
                required
              />
            ) : null}
          </div>
          {showCalendar() ? (
            <div className="input-row flex flex-col ">
              <div>
                <DaySelector
                  label={t("perfil_de_curso_formulario_calendario")}
                  labelInstruction={t(
                    "perfil_de_curso_formulario_calendario_instruction"
                  )}
                  selectedData={selectedDaysData}
                  selectedGradeLevel={selectedGradeLevel}
                />
              </div>
              {errorCalendar && (
                <div className="text-Red-500 text-sm font-semibold pt-4 text-center">
                  {t("campo_requerido")}
                </div>
              )}
            </div>
          ) : null}

          {/* Hidde temporary */}
          {false && (
            <div className="input-row">
              <div className="input-text">
                <label className="input-label">
                  {t("perfil_de_curso_formulario_recursos")}
                </label>
                <label className="input-instruction">
                  {t("perfil_de_curso_formulario_recursos_instruction")}
                </label>
                <div className="flex flex-row sm-max:flex-col justify-around items-center w-full gap-4 ">
                  <Button
                    label={t("perfil_de_curso_formulario_recursos_cargar")}
                    variant="tertiary-rounded"
                    onClick={togglePopup}
                    disabled={gptLoading}
                    typeB={"button"}
                  />
                  {availableAssets.length ? (
                    <>
                      <span className="text-4 leading-4 text-LightBlue-500 flex h-full items-center justify-center">
                        o
                      </span>
                      <div className="flex-1 flex flex-row gap-0 sm-max:flex-col sm-max:gap-2 justify-center items-center">
                        <label className="sm:z-10 h-[42px] sm-max:w-full pl-4 pr-2 flex items-center justify-center text-3.5 leading-3.5 font-bold sm:rounded-tl-2 sm:rounded-bl-2 sm-max:rounded-2 bg-DarkBlue-800 text-Grey-500">
                          {t(
                            "perfil_de_curso_formulario_seleccionar_biblioteca"
                          )}
                        </label>
                        <SelectInput
                          name="existing_asset"
                          options={availableAssets?.map((e) => ({
                            value: e.id,
                            label: e.name,
                          }))}
                          customClassName="mt-0 sm:-ml-2"
                          placeholder={t(
                            "perfil_de_curso_biblioteca_placeholder"
                          )}
                        />
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          )}
          {/* Hidde temporary */}

          <div>
            <div className="input-text">
              <label className="input-label px-0">
                {t("perfil_de_curso_formulario_conocimiento_previo_label")}
              </label>
              <label className="input-instruction px-0">
                {t(
                  "perfil_de_curso_formulario_conocimiento_previo_instruction"
                )}
              </label>
              <div className="flex justify-around gap-2">
                <div className="w-full">
                  <Controller
                    name="previousKnowledge"
                    control={methods.control}
                    rules={{ required: t("campo_requerido") }}
                    render={({ field }) => (
                      <CreatableSelect
                        {...field}
                        cacheOptions
                        options={selected?.previousKnowledge?.map((e) => ({
                          label: e.description,
                          value: e.id,
                        }))}
                        styles={SelectStyles}
                        isMulti
                        placeholder={t(
                          "perfil_de_curso_formulario_conocimiento_previo_placeholder"
                        )}
                        formatCreateLabel={(inputValue) =>
                          `Crear "${inputValue}"`
                        }
                        onCreateOption={(e) =>
                          handleCreateTag(e, "previousKnowledge")
                        }
                      />
                    )}
                  />
                  {errors.previousKnowledge && (
                    <span className="input-error">
                      {errors.previousKnowledge.message}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="input-text">
              <label className="input-label px-0">
                {t("perfil_de_curso_formulario_recursos1_label")}
              </label>
              <label className="input-instruction px-0">
                {t("perfil_de_curso_formulario_recursos1_instruction")}
              </label>
              <div className="flex justify-around gap-2">
                <div className="w-full">
                  <Controller
                    name="resources"
                    control={methods.control}
                    rules={{ required: t("campo_requerido") }}
                    render={({ field }) => (
                      <CreatableSelect
                        {...field}
                        cacheOptions
                        options={selected?.resources?.map((e) => ({
                          label: e.description,
                          value: e.id,
                        }))}
                        styles={SelectStyles}
                        isMulti
                        placeholder={t(
                          "perfil_de_curso_formulario_recursos1_placeholder"
                        )}
                        formatCreateLabel={(inputValue) =>
                          `Crear "${inputValue}"`
                        }
                        onCreateOption={(e) => handleCreateTag(e, "resources")}
                      />
                    )}
                  />
                  {errors.resources && (
                    <span className="input-error">
                      {errors.resources.message}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="input-text">
              <label className="input-label px-0">
                {t("perfil_de_curso_formulario_consideraciones")}
              </label>
              <label className="input-instruction px-0">
                {t("perfil_de_curso_formulario_consideraciones_instruction")}
              </label>
              <div className="flex justify-around gap-2">
                <div className="w-full">
                  <Controller
                    name="considerations"
                    control={methods.control}
                    rules={{ required: t("campo_requerido") }}
                    render={({ field }) => (
                      <CreatableSelect
                        {...field}
                        cacheOptions
                        options={selected?.considerations?.map((e) => ({
                          label: e.description,
                          value: e.id,
                        }))}
                        styles={SelectStyles}
                        isMulti
                        placeholder={t(
                          "perfil_de_curso_formulario_consideraciones_placeholder"
                        )}
                        formatCreateLabel={(inputValue) =>
                          `Crear "${inputValue}"`
                        }
                        onCreateOption={(e) =>
                          handleCreateTag(e, "considerations")
                        }
                      />
                    )}
                  />
                  {errors.considerations && (
                    <span className="input-error">
                      {errors.considerations.message}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="form-CTA">
            <button
              onClick={() => customSubmit()}
              type="button"
              disabled={loading}
              className="bg-[#3d96c2] text-[#28345c] font-bold rounded-lg p-3"
            >
              {loading
                ? t("perfil_de_curso_formulario_boton_enviando")
                : selected?.id || selectedRow?.id
                ? t("perfil_de_curso_formulario_boton_actualizar")
                : t("perfil_de_curso_formulario_boton_crear")}
            </button>
          </div>

          <Modal3
            isOpen={showDbaModal}
            onClose={closeDbaModal}
            customClassName="w-[60%]"
          >
            <div className="p-4 flex flex-col gap-2">
              <div className="input-text gap-4 mt-0">
                <div className="flex justify-around flex-col">
                  <SelectInput
                    name="areaKnowledge"
                    label={t(
                      "perfil_de_curso_general_modal_dba_area_conocimiento_label"
                    )}
                    labelInstruction={t(
                      "perfil_de_curso_general_modal_dba_area_conocimiento_instruction"
                    )}
                    options={areaKnowledge}
                    customClassName="mt-0"
                    placeholder={t(
                      "perfil_de_curso_general_modal_dba_area_conocimiento_placeholder"
                    )}
                  />
                  {errors.areaKnowledge && (
                    <span className="input-error">
                      {errors.areaKnowledge.message}
                    </span>
                  )}
                </div>
                <div className="flex justify-around flex-col">
                  <SelectInput
                    name="standard"
                    label={t(
                      "perfil_de_curso_general_modal_dba_estandar_label"
                    )}
                    labelInstruction={t(
                      "perfil_de_curso_general_modal_dba_estandar_instruction"
                    )}
                    options={standard}
                    customClassName="mt-0"
                    placeholder={t(
                      "perfil_de_curso_general_modal_dba_estandar_placeholder"
                    )}
                  />
                  {errors.standard && (
                    <span className="text-Red-500 text-sm font-semibold pt-4">
                      {errors.standard.message}
                    </span>
                  )}
                </div>
                <div className="flex justify-around flex-col">
                  <SelectInput
                    name="performance"
                    label={t(
                      "perfil_de_curso_general_modal_dba_desempeno_label"
                    )}
                    labelInstruction={t(
                      "perfil_de_curso_general_modal_dba_desempeno_instruction"
                    )}
                    options={performance}
                    customClassName="mt-0"
                    placeholder={t(
                      "perfil_de_curso_general_modal_dba_desempeno_placeholder"
                    )}
                  />
                  {errors.performance && (
                    <span className="text-Red-500 text-sm font-semibold pt-4">
                      {errors.performance.message}
                    </span>
                  )}
                </div>
                <div className="w-full">
                  <div className="input-label text-sm text-center">
                    {t(
                      "perfil_de_curso_general_modal_dba_desempenos_seleccionados"
                    )}
                  </div>
                  <div className="text-white">
                    Morem ipsum dolor sit amet, consectetur adipiscing elit.
                    Etiam eu turpis molestie, dictum est a, mattis tellus. Sed
                    dignissim, metus nec fringilla accumsan, risus sem
                    sollicitudin lacus, ut interdum tellus elit sed risus.
                  </div>
                </div>
                <div className="flex justify-center pt-4 pb-8">
                  <button
                    type="button"
                    onClick={() => handleSelectDba()}
                    className="bg-[#3d96c2] text-[#28345c] font-bold rounded-lg p-3"
                  >
                    {t("perfil_de_curso_general_modal_dba_boton_terminar")}
                  </button>
                </div>
              </div>
            </div>
          </Modal3>
          <Modal3
            isOpen={showDocumentModal}
            onClose={closeDocumentModal}
            customClassName="w-[95%] max-h-[95%] p-4"
            customHeight="max-h-[95%]"
          >
            <FileUploaderCourseProfile
              onFileSelect={handleFiles}
              onClose={closeDocumentModal}
            />
          </Modal3>
          <Modal3
            isOpen={showVideotModal}
            onClose={closeVideoModal}
            customClassName="w-[50%] top-[35%]"
          >
            <div className="mr-5">
              <ReactPlayer
                url="https://www.youtube.com/watch?v=wrtmpLqeYGc"
                playing={showVideotModal}
              />
            </div>
          </Modal3>
          <Modal3
            isOpen={showConfirmationAssetDeleteModal}
            onClose={() => setShowConfirmationAssetDeleteModal(false)}
            customClassName="w-[30%] top-[35%]"
          >
            <div className="flex flex-col gap-3">
              <div className="text-shaiaBlue">Eliminar documento?</div>
              <div className="flex gap-3 justify-around ">
                <button
                  className="bg-Red-500 border-Red-500 p-3 rounded-lg text-white font-bold w-full"
                  onClick={() => handleRemoveAsset()}
                  disabled={loading}
                >
                  {loading ? "Eliminando ..." : "Si"}
                </button>
                <button
                  className="bg-DarkBlue-700 text-shaiaBlue border-shaiaBlue border-2 p-3 rounded-lg font-bold w-full"
                  onClick={() => setShowConfirmationAssetDeleteModal(false)}
                  disabled={loading}
                >
                  No
                </button>
              </div>
            </div>
          </Modal3>
        </form>
      </FormProvider>
    </>
  );
};

export default FormCourseProfile;
